import {FormattedMessage} from 'react-intl';
import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import {SuccessIcon} from '../../Icon';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import PropTypes from 'prop-types';

export default function EnvelopeCreationSuccessPopup(props) {
    return (
        <Dialog open={true}>
            <DialogContent style={{paddingBottom: 0}}>
                <div style={{marginRight: 10, marginBottom: 10}}>
                    <span className="font-italic text-success">
                        <SuccessIcon className="success" size="6%"/>
                        <FormattedMessage id={'labels.ENVELOPE_SUCCESSFULLY_SENT'}/>...{' '}
                    </span>
                    <Button
                        color="primary"
                        href={`/signAgreement?agreementNumber=${props.quoteNumber}`}
                        size="small"
                        variant="contained"
                    >
                        <FormattedMessage id={'labels.BACK_TO_DASHBOARD'}/>
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}

EnvelopeCreationSuccessPopup.propTypes = {
    quoteNumber: PropTypes.string.isRequired
}
